import * as React from 'react';
import { ReportCommonApi } from 'app/area/reports/types-api';
import { GroupByFieldState } from 'app/area/reports/containers/group-by/types-store';
import { ChartState } from 'app/area/reports/containers/chart/types-store';
import { SelectionGroupByContainer } from 'app/area/reports/containers/group-by/group-by-container-selection-report';
import { FrequencyGroupByContainer } from 'app/area/reports/containers/group-by/group-by-container-frequency-report';

export interface GroupByContainerProps {
  orderNumber: string;
  disabled: boolean;
  translation: any;
  groupByFieldState: GroupByFieldState;
  chartState: ChartState;
  isFrequencyReport?: boolean;
}

export const GroupByContainerForApi = (api: ReportCommonApi) => ({
  orderNumber,
  translation,
  disabled,
  groupByFieldState,
  chartState,
  isFrequencyReport
}: GroupByContainerProps) => {
  return isFrequencyReport
    ? <FrequencyGroupByContainer
        api={api}
        orderNumber={orderNumber}
        translation={translation}
        disabled={disabled}
        groupByFieldState={groupByFieldState}
        chartState={chartState}
    />
    : <SelectionGroupByContainer 
        api={api}
        orderNumber={orderNumber}
        translation={translation}
        disabled={disabled}
        groupByFieldState={groupByFieldState}
        chartState={chartState}
    />;
};
